import { default as errors } from './errors.json'

// Buckets in errors.json that are not endpoints: shared error codes and a last
// resort keyed on the HTTP status. Both are only consulted once the endpoint
// specific lookups have missed.
const SHARED = '*'
const STATUS = '*status'

export const getDefaultErrorMessage = () => {
  return APP.lang === 'sv' ? 'Oj, något gick fel. Var vänlig försök igen' : 'Oops! Something went wrong, please try again'
}

// api.js always calls with a /v1 prefix that the proxy strips, and some endpoints
// carry a query string. Neither is part of the keys in errors.json.
const normalize = endPoint => String(endPoint ?? '').split('?')[0].replace(/^\/v\d+/, '')

const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// '/users/{userId}/vouchers' -> /^\/users\/[^/]+\/vouchers$/
const toPattern = key => new RegExp('^' + key.split(/\{[^}]+\}/).map(escapeRegExp).join('[^/]+') + '$')

export const getErrorMessage = (endPoint, error, status) => {
  const path = normalize(endPoint)

  if (errors[path]?.[error]?.[APP.lang]) {
    return errors[path][error][APP.lang]
  }

  // Endpoints with an id in the path need a pattern match. Keep this anchored to
  // the endpoint: matching on the error code alone hands back whichever endpoint
  // happens to define that code first in errors.json.
  for (const [key, value] of Object.entries(errors)) {
    if (key === SHARED || key === STATUS) continue
    if (toPattern(key).test(path) && value[error]?.[APP.lang]) {
      return value[error][APP.lang]
    }
  }

  if (errors[SHARED]?.[error]?.[APP.lang]) {
    return errors[SHARED][error][APP.lang]
  }

  // Nothing knows this code, but the status still tells the user something useful.
  if (errors[STATUS]?.[status]?.[APP.lang]) {
    return errors[STATUS][status][APP.lang]
  }

  return getDefaultErrorMessage()
}
